const rarityText = `

Chicken Figthers: 
                              unique  3  
                              Mythic: 15
                              Legendary :75 
                              Rare: 250 
                              Uncommon :400
                              Common :757

Staking and Tokenomics :

Stake your Chicken fighter and earn $KAI tokens Daily .
Total supply :15,000,000 $KAI

Tokens distribution 60$KAI/Day (Unique)
                                               45$KAI/Day (Mythic))
	                                  35$KAI/Day (Legendary)
	                                  25$KAI/Day (Rare)
	                                  20$KAI/Day (Uncommon)
	                                  10$KAI/Day (Common)

$KAI token Utility:
2 Chickens will be needed for breeding + 150 $KAI  
Hatching = 70 $KAI


`;

export default rarityText;
